import React from "react";
import styled from "styled-components";

const AdminSidebar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background: #0d1220;
  border-right: 1px solid #1f2937;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-110%)")};
  transition: 0.35s ease;
  padding: 20px;
  z-index: 9999;
`;

function AdminPanel({ open, setOpen, adminMode, setAdminMode }) {
  return (
    <AdminSidebar open={open}>
      <h3>Admin Tools</h3>
      <p style={{ opacity: 0.7, fontSize: 13 }}>
        Toggle inline editing and manage advanced settings.
      </p>
      <div style={{ marginTop: 12 }}>
        <label style={{ fontSize: 13, color: '#e5e7eb', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={adminMode}
            onChange={(e) => setAdminMode(e.target.checked)}
            style={{ marginRight: 6 }}
          />
          Enable inline edit
        </label>
      </div>
      <button style={{ marginTop: 16, padding: '10px 20px', background: '#111827', border: '1px solid #1f2937', color: '#e5e7eb', borderRadius: 10, cursor: 'pointer' }} onClick={() => setOpen(false)}>
        Close Admin
      </button>
    </AdminSidebar>
  );
}

export default AdminPanel;

